import { requestHelpers } from '../../helpers';

const actions = {
    GET_PREVIOUS_PAGE: 'GET_PREVIOUS_PAGE',
    SET_PREVIOUS_PAGE: 'SET_PREVIOUS_PAGE',
    GET_NEXT_PAGE: 'GET_NEXT_PAGE',
    SET_NEXT_PAGE: 'SET_NEXT_PAGE',
    GET_GO_TO_PAGE: 'GET_GO_TO_PAGE',
    SET_GO_TO_PAGE: 'SET_GO_TO_PAGE',
};

function getPreviousPage( page ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_PREVIOUS_PAGE,
        } );

        requestHelpers
            .authenticatedGetRequest( '/jobs', { page } )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_PREVIOUS_PAGE,
                    page: response.data,
                } );
            } );
    }
}

function getNextPage( page ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_NEXT_PAGE,
        } );

        requestHelpers
            .authenticatedGetRequest( '/jobs', { page } )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_PREVIOUS_PAGE,
                    page: response.data,
                } );
            } );
    }
}

function getGoToPage( page ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_PREVIOUS_PAGE,
        } );

        requestHelpers
            .authenticatedGetRequest( '/jobs', { page } )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_PREVIOUS_PAGE,
                    page: response.data,
                } );
            } );
    }
}

module.exports = {
    actions,
    getPreviousPage,
    getNextPage,
    getGoToPage,
};



// WEBPACK FOOTER //
// src/client/actions/common/pagination.js